import socialConfig from "@configs/social_config.json";
import type { SidebarSocialProps } from "./components/Social/types";
import type { SidebarSocialRowsProps } from "./components/SocialRows/types";

export const homeSocialCounters = {
  facebook: socialConfig.facebook,
  instagram: socialConfig.instagram,
  twitter: socialConfig.twitter,
} satisfies SidebarSocialProps["counters"];

export const socialRowsCounters = {
  ...homeSocialCounters,
  youtube: socialConfig.youtube,
  tiktok: socialConfig.tiktok,
} satisfies SidebarSocialRowsProps["counters"];
